import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getCurrencySettingsRequest = {};
var _getCurrencySettingsResponse = {};
function resolveComWixpressPremiumStoreCurrencyV1PremiumCurrencySettingsUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/premium-store',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/store',
                destPath: '',
            },
            {
                srcPath: '/_api/premium-store',
                destPath: '/api',
            },
            {
                srcPath: '/pricing/premium-plans',
                destPath: '/plans',
            },
            {
                srcPath: '/_api/mailbox-store',
                destPath: '',
            },
            {
                srcPath: '/upgrade/website',
                destPath: '/upgradeWebsite',
            },
            {
                srcPath: '/wix/api/premiumStartTest',
                destPath: '/plans',
            },
            {
                srcPath: '/wix/api/premiumStart',
                destPath: '/plans',
            },
            {
                srcPath: '/_api/wix/premiumStart',
                destPath: '/plans',
            },
            {
                srcPath: '/pricing',
                destPath: '/upgradeWebsite',
            },
            {
                srcPath: '/studio/pricing',
                destPath: '/upgradeWebsite',
            },
        ],
        'premium._base_domain_': [
            {
                srcPath: '/_api/premium-store',
                destPath: '',
            },
            {
                srcPath: '/_api/mailbox-store',
                destPath: '',
            },
            {
                srcPath: '/wix/api/premiumStartTest',
                destPath: '/plans',
            },
            {
                srcPath: '/wix/api/premiumStart',
                destPath: '/plans',
            },
            {
                srcPath: '/_api/wix/premiumStart',
                destPath: '/plans',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/store',
                destPath: '/api',
            },
            {
                srcPath: '/store',
                destPath: '',
            },
            {
                srcPath: '/_api/premium-store',
                destPath: '/api',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/store',
                destPath: '/api',
            },
            {
                srcPath: '/store',
                destPath: '',
            },
            {
                srcPath: '/_api/premium-store',
                destPath: '/api',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/store',
                destPath: '/api',
            },
            {
                srcPath: '/store',
                destPath: '',
            },
            {
                srcPath: '/_api/premium-store',
                destPath: '/api',
            },
        ],
        _: [
            {
                srcPath: '/_api/store/plans/premiumStatus',
                destPath: '/api/plans/premiumStatus',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/store',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/pricing/premium-plans',
                destPath: '/plans',
            },
            {
                srcPath: '/store',
                destPath: '',
            },
            {
                srcPath: '/upgrade/website',
                destPath: '/upgradeWebsite',
            },
            {
                srcPath: '/_api/mailbox-store',
                destPath: '',
            },
            {
                srcPath: '/_api/premium-store',
                destPath: '/api',
            },
            {
                srcPath: '/wix/api/premiumStart',
                destPath: '/plans',
            },
            {
                srcPath: '/_api/wix/premiumStart',
                destPath: '/plans',
            },
            {
                srcPath: '/wix/api/premiumStartTest',
                destPath: '/plans',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Get currency settings for the required country and language and currency */
export function getCurrencySettings(payload) {
    var _a = serializer(_getCurrencySettingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCurrencySettingsResponse, {}).fromJSON;
    function __getCurrencySettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.store.v1.currency',
            method: 'GET',
            methodFqn: 'com.wixpress.premium.store.currency.v1.PremiumCurrencySettings.GetCurrencySettings',
            url: resolveComWixpressPremiumStoreCurrencyV1PremiumCurrencySettingsUrl({
                protoPath: '/api/v1/currencySettings',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCurrencySettings.fromReq = fromReq;
    __getCurrencySettings.__isAmbassador = true;
    return __getCurrencySettings;
}
//# sourceMappingURL=http.impl.js.map